import CloseIcon from '@mui/icons-material/Close';
import { Box, Button, Drawer, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { Stack } from '@mui/system';
import * as React from 'react';

import { useBasicExitIntent } from '@/hooks/useBasicExitIntent';

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

const Popup15397 = () => {
  const [open, setOpen] = React.useState(false);

  useBasicExitIntent(() => {
    setOpen(true);
  });

  const handleClose = () => {
    sessionStorage.setItem('tzo-exit-intent', 'exit');
    setOpen(false);
  };

  return (
    <>
      <Drawer
        className="exit-popup"
        anchor="left"
        onClose={handleClose}
        open={open}
        variant="temporary"
        PaperProps={{
          sx: {
            maxWidth: { xs: 320, sm: 500 },
            background: '#f5f5f5',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            px: 2,
          },
        }}
      >
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <Box component="div" sx={{ textAlign: 'center', mt: 0 }}>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 2, md: 2 }}
            alignItems="center"
            justifyContent="space-around"
          >
            <Box sx={{ textAlign: { xs: 'center', sm: 'center' } }}>
              <Box
                component="img"
                src="/assets/images/wait-img.png"
                alt="Just a sec! Before you go."
                sx={{ maxWidth: { xs: 150, sm: 150, md: 150, lg: 200 }, mt: 3 }}
              />
              <Typography
                variant="body1"
                color="primary"
                sx={{
                  fontWeight: 600,
                  fontSize: { xs: 18, sm: 20, md: 22 },
                  color: '#da4b4b',
                  mb: 1,
                }}
              >
                ⏳ Wait! Don’t Miss <br />
                <span style={{ color: '#000' }}> Your Extension!</span>
              </Typography>
              {/* <Typography
                variant="body1"
                color="primary"
                sx={{ color: '#333', mb: 2 }}
              >
                The <span style={{ fontWeight: 600 }}> Form 8868</span> deadline
                is <span style={{ fontWeight: 600 }}>May 15, 2026</span>.
              </Typography> */}
              <Typography
                gutterBottom
                variant="body1"
                sx={{
                  fontWeight: 400,
                  fontSize: { xs: 13, sm: 15, md: 17 },
                  mb: 0,
                  lineHeight: 1.5,
                }}
              >
                <span style={{ fontWeight: 600 }}>
                  {' '}
                  Need more time to furnish recipient statements?
                </span>{' '}
                <br />
                File Form 15397 now to request a one-time extension of up to 30
                days and stay compliant with IRS deadlines.
              </Typography>
            </Box>
          </Stack>
          <Stack
            direction={{ xs: 'column', sm: 'column' }}
            spacing={{ xs: 1, sm: 2, md: 4 }}
            sx={{}}
          >
            <Box>
              <Typography
                component="div"
                variant="body1"
                sx={{
                  fontSize: { xs: 12, sm: 15, md: 18 },
                  mt: 2,
                  textAlign: 'center',
                  maxWidth: 580,
                  fontWeight: 600,
                  mx: 'auto',
                }}
              >
                Exclusive Offer:
              </Typography>
              <Box
                sx={{
                  m: 0,
                  mx: 'auto',
                  mb: 2,
                  maxWidth: 350,
                  p: 1,
                  fontSize: { xs: 11, sm: 12, md: 14 },
                  fontWeight: 400,
                  lineHeight: 1.2,
                  border: '2px dashed rgb(113, 81, 0)',
                  backgroundColor: 'rgb(255, 250, 205)',
                }}
              >
                Use code
                <br />
                <Box
                  component="strong"
                  sx={{
                    ml: 0,
                    color: '#fd5345',
                    fontWeight: 600,
                    fontSize: { xs: 16, sm: 18, md: 20 },
                  }}
                >
                  TZOEXT10
                </Box>
                <br />
                at checkout for
                <br />
                <b>10% off your filing fee!</b>
              </Box>
            </Box>
          </Stack>
        </Box>

        <Box sx={{ px: { xs: 1, sm: 3 }, mb: 1 }}>
          <Typography variant="body2" sx={{ textAlign: 'center', mb: 0.5 }}>
            Don&apos;t risk late penalties
          </Typography>
          <Button
            variant="contained"
            size="large"
            sx={{
              textTransform: 'none',
              boxShadow: 'none',
              borderRadius: 3,
              display: 'inline-block',
            }}
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form15397&utm_source=exit+pop+up`}
          >
            File Now & Save 10%
          </Button>
        </Box>
      </Drawer>
    </>
  );
};

export default Popup15397;
